/*
 * Component for app logo
 */
import React, { Component } from 'react';
import { alpha } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';

import { Avatar, Tooltip } from '@mui/material';

const styleSheet = theme => ({
  root: {
      flexGrow: 1
  },
  flex: {
      flex: 1,
  },
  avatar: {
    backgroundColor: theme.palette.nav.backgroundColor,
  },
  avatarLogo: {
    backgroundColor: alpha('#ffffff', 0),
  },
  small: {
    width: '24px',
    height: '24px',
  },
  large: {
    width: '48px',
    height: '48px',
  },
  verylarge: {
    width: '80px',
    height: '80px',
  }
});

class AppLogo extends Component {
    render() {
       const classes = this.props.classes;
 
        let logoPath    = this.props.logoPath;
        let appName     = this.props.appName;
        let imageHeight = this.props.imageHeight;
        let theStyle    = this.props.style;
        let displayAvatar = false;
        let avatarSizeClass = 'small';
        let theTooltip  = this.props.theTooltip;

        let theAppInitial = "";
        if (logoPath == null || logoPath === '') {
          displayAvatar = true;
          if (appName != null && appName.length > 0) {
            theAppInitial = appName.substring(0,1);
          }
        }

        if (imageHeight == null) {
            imageHeight = '24px';
            avatarSizeClass = 'small';
        } else if (imageHeight === '24px') {
          avatarSizeClass = 'small';
        } else if (imageHeight === '48px') {
          avatarSizeClass = 'large';
        } else if (imageHeight === '80px') {
          avatarSizeClass = 'verylarge';
        } else {
          //there should only be 2 sizes system wide, default small if anything else passed
          avatarSizeClass = 'small';
        }

        if (displayAvatar) {
          if (theTooltip != null) {
            return (
              <Tooltip title={appName} aria-label={appName} placement="right">
                <Avatar height={imageHeight} variant="rounded" className={classNames(classes.avatar, classes[avatarSizeClass])} style={theStyle}>{theAppInitial}</Avatar>
              </Tooltip>
            );
          } else {
            return (
              <Avatar height={imageHeight} variant="rounded" className={classNames(classes.avatar, classes[avatarSizeClass])} style={theStyle}>{theAppInitial}</Avatar>
            );
          }
        } else {
          if (theTooltip != null) {
            return (
              <Tooltip title={appName} aria-label={appName} placement="right">
                <Avatar height={imageHeight} variant="rounded" className={classNames(classes.avatarLogo, classes[avatarSizeClass])} style={theStyle} src={logoPath}/>
              </Tooltip>
            );
          } else {
            return (
              <Avatar height={imageHeight} variant="rounded" className={classNames(classes.avatarLogo, classes[avatarSizeClass])} style={theStyle} src={logoPath}/>
            );
          } 
        }
    }
}

export default withStyles(styleSheet)(AppLogo);
